import EventEmitter from "eventemitter3";
import fileSys from "../../../fileoprators/fileSystem";
import {
  getSystemTime,
  isArray,
  isArrayEmpty,
  isDefined,
  isFunction,
  isPlainObject,
  isStringEmpty,
  isTrue,
  logStdout
} from "../../../shared/utils";
import procWorklistData from "./worklist-proc";
import moment from "moment";
import { addPatient, getOnePatient } from "../../../services/patient";
const fs = window.require("fs");
const iconv = window.require("iconv-lite");
const { spawn, exec } = window.require("child_process");
const encoding = window.require("encoding");
const ENV = { env: { DCMDICTPATH: fileSys.getUtilPath("dicom.dic") } };
let isDownloading = false;
let timeout;
let dicomInterval;
const DCMTKTOOLS = {
  dcmdjpeg: "dcmdjpeg",
  dump2dcm: "dump2dcm",
  findscu: "findscu",
  img2dcm: "img2dcm",
  pdf2dcm: "pdf2dcm",
  storescu: "storescu",
  echoscu: "echoscu",
  dcmodify: "dcmodify"
};
for (let id in DCMTKTOOLS) {
  exec("chmod +x " + fileSys.getUtilPath(DCMTKTOOLS[id]), () => {});
}
class Dicom extends EventEmitter {
  constructor() {
    super();
    this.sexes = {
      zh_CN: { F: "女", M: "男" }
    };
    this.lang = "zh_CN";
    logStdout("dicom settings", window.dicomSettings);
    this.dicomTempPath = fileSys.getDicomTmpFilePath();
    this.dicomTempImgPath = fileSys.getDicomTmpFilePath("images");
  }
  clearDicomPath(callback) {
    fileSys.clearAllFiles(
      this.dicomTempPath,
      [".dcm", ".jpg", ".bmp", ".wl", ".dump", ".png", ".pdf"],
      () => {
        fileSys.clearAllFiles(
          this.dicomTempImgPath,
          [".dcm", ".jpg", ".bmp", ".wl", ".dump", ".png", ".pdf"],
          () => {
            if (callback) callback();
          }
        );
      }
    );
  }
  judgeCanBeUpload() {
    let state = true;
    for (let i in arguments) {
      if (arguments[i] === "") {
        state = false;
      }
    }
    return state;
  }

  getUtilFilePath(file) {
    return fileSys.getUtilPath(file);
  }
  getConfigFilePath(file) {
    return fileSys.getCfgPath(file);
  }
  isWorklistPatientTxtExists() {
    return fs.existsSync(this.getConfigFilePath("worklistPatient.txt"));
  }
  deleteWorlistPatientTxt() {
    try {
      if (this.isWorklistPatientTxtExists()) {
        fs.unlinkSync(this.getConfigFilePath("worklistPatient.txt"));
      }
    } catch (e) {}
  }
  getWorklistInterval() {
    let interval =
      typeof window.dicomSettings.interval === "string"
        ? parseInt(window.dicomSettings.interval)
        : window.dicomSettings.interval;
    this.clearWorklistInteval(dicomInterval);
    dicomInterval = setInterval(() => {
      this.getWorklistData((state) => {
        if (window.dicomSettings.enable && isTrue(state)) {
          this.emit("dicom-update");
        } else {
          this.clearWorklistInteval(dicomInterval);
          this.emit("dicom-stopped");
          window.dicomSettings.enable = false;
        }
      });
    }, interval * 1000);
  }
  clearWorklistInteval() {
    clearInterval(dicomInterval);
  }
  enableDicom() {
    this.getWorklistData((error) => {
      if (window.dicomSettings.enable && !isDefined(error)) {
        this.getWorklistInterval();
      } else {
        this.emit("dicom-stopped");
        window.dicomSettings.enable = false;
      }
    });
  }

  procLocalPatient() {
    let worlistTxt = fileSys.readFile(this.getConfigFilePath("worklistPatient.txt"), "binary");
    let charset = window.dicomSettings.worklist.worklistcharset;
    if (!isDefined(worlistTxt)) {
      return null;
    }
    if (isStringEmpty(worlistTxt)) {
      return [];
    }
    let outdata = "";
    let buffer = Buffer.from(worlistTxt, "binary");
    switch (charset) {
      case "utf8":
        outdata = iconv.decode(buffer, "utf8");
        break;
      case "gbk":
        outdata = iconv.decode(buffer, "gbk");
        break;
      default:
        outdata = iconv.decode(buffer, "utf8");
        break;
    }
    logStdout("dicom worklist patient content in .txt", outdata);
    let response = procWorklistData(outdata);

    if (!isPlainObject(response)) return [];
    let { results } = response;
    if (!isArray(results) || isArrayEmpty(results)) return [];
    let _patients = [];
    for (let id = 0; id < results.length; id++) {
      let pat = {};
      let result = results[id];
      let arr = result["0010,0010"].value.split("^");
      pat.firstname = (arr[0] || "").trim();
      pat.lastname = (arr[1] || "").trim();
      let birth = result["0010,0030"].value.trim();
      pat.birthday = moment(birth).format("YYYY-MM-DD");
      let sex = result["0010,0040"].value.trim();
      pat.sex = this.getSex(sex);
      pat.pid = (result["0010,0020"].value || "").trim();
      _patients.push(pat);
      pat.dicominfo = result;
    }
    // logStdout('dicom patient after procLocalPatient', _patients)
    return _patients;
  }
  getSex(v) {
    let _sex = "";
    let sex = v.toUpperCase();
    switch (sex) {
      case "男":
        _sex = "M";
        break;
      case "女":
        _sex = "F";
        break;
      case "MALE":
        _sex = "M";
        break;
      case "FEMALE":
        _sex = "F";
        break;
      case "M":
        _sex = "M";
        break;
      case "F":
        _sex = "F";
        break;
      default:
        break;
    }
    return _sex;
  }
  execCallback() {
    if (isDownloading) {
      let args = [];
      let len = arguments.length;
      for (let id = 0; id < len - 1; id++) {
        args.push(arguments[id]);
      }
      let callback = arguments[len - 1];
      if (isDownloading && isFunction(callback)) {
        // eslint-disable-next-line standard/no-callback-literal
        callback(...args);
      }
    }
  }
  getWorklistData(callback) {
    let { serverip, serverport, aetitle, localae, startdate, enddate, modality } =
      window.dicomSettings.worklist;
    let startDate =
      startdate && startdate !== ""
        ? moment(startdate).format("YYYYMMDD")
        : moment().format("19000101");
    let endDate =
      enddate && enddate !== "" ? moment(enddate).format("YYYYMMDD") : moment().format("YYYYMMDD");
    this.deleteWorlistPatientTxt();
    let params = [
      this.getUtilFilePath(DCMTKTOOLS.findscu),
      serverip,
      serverport,
      "-aec",
      aetitle,
      "-aet",
      localae,
      "-k",
      `"(0040,0100)[0].(0008,0060)=${modality}"`,
      "-W",
      "-k",
      `"(0040,0100)[0].(0040,0002)=${startDate}-${endDate}"`,
      "-k",
      `"(0040,0100)[0].(0040,0001)=${localae}"`,
      this.getUtilFilePath("wlistqry0.wl"),
      "2>" + this.getConfigFilePath("worklistPatient.txt")
    ];
    logStdout("dicom get work list data params", params.join(" "));
    exec(params.join(" "), ENV, (err, stdout, stderr) => {
      if (err) {
        logStdout("dicom get work list data error", err.message);
        this.execCallback(err, callback);
        return;
      }
      if (stderr) {
        logStdout("dicom get work list data stderr", stderr);
        if (this.isStdErrOK(stderr) === false) {
          this.execCallback(stderr, callback);
          return;
        } else {
          this.execCallback(callback);
        }
      }
      this.execCallback(callback);
    });
  }
  testWorklist(config) {
    this.testDicom(config, "worklist");
  }
  testPdf(config) {
    this.testDicom(config, "pdf");
  }
  modifyDCM(patient, record, dcmfile, callback) {
    let modality = window.dicomSettings.pdf.modality;
    let accessionnum = patient.dicominfo["0008,0050"].value;
    let charset = '"ISO_IR 192"';
    let datetime = (record.recorddate || getSystemTime()).split(" ");
    let stdate = datetime[0].replace(/-/g, "");
    let sttime = datetime[1].replace(/:/g, "");
    datetime = (record.testtime || getSystemTime()).split(" ");
    let imgdate = datetime[0].replace(/-/g, "");
    let imgtime = datetime[1].replace(/:/g, "");
    let params = [
      `0008,0060=${modality}`,
      `0008,0020=${stdate}`,
      `0008,0023=${imgdate}`,
      `0008,0030=${sttime}`,
      `0008,0033=${imgtime}`,
      `0008,0005=${charset}`,
      `0008,0050=${accessionnum}`
    ];
    let cmd = `${this.getUtilFilePath(DCMTKTOOLS.dcmodify)} ${"-m " + params.join(" -m ")} ${dcmfile}`;
    logStdout("dicom-modality dcm cmd", cmd);
    exec(cmd, ENV, (err) => {
      if (err) {
        logStdout("dicom modality error", err);
        callback(err);
      } else {
        callback(null);
      }
    });
  }
  testDicom(config, type = "worklist") {
    // if (type === 'worklist') {
    //   tool = DCMTKTOOLS.findscu
    //   params = isStringEmpty(config.aetitle)
    //     ? [config.serverip, config.serverport, '-to', '5', this.getUtilFilePath('wlistqry0.wl')]
    //     : [config.serverip, config.serverport, '-to', '5', '-aec', config.aetitle, this.getUtilFilePath('wlistqry0.wl')]
    // } else {
    //   tool = DCMTKTOOLS.echoscu
    //   params = [config.serverip, config.serverport, '-to', '5']
    // }
    let tool = DCMTKTOOLS.echoscu;
    let params = [config.serverip, config.serverport, "-aec", config.aetitle, "-to", "5"];
    logStdout(`test dicom - ${type}`, params.join(" "));
    // ./findscu 192.168.31.82 3000 -to 5 -aec OFFIS -k '0008,0050=a' wlistqry0.wl
    // ./echoscu 192.168.31.82 104 -to 5 -aec OFFIS
    let spawner = spawn(this.getUtilFilePath(tool), params, ENV);
    let isOK = true;
    let resData = "";
    spawner.stdout.on("data", (data) => {
      logStdout(`test dicom - ${type} stdout`, data.toString());
      resData = data;
    });

    spawner.stderr.on("data", (data) => {
      logStdout(`test dicom - ${type} stderr`, data.toString());
      resData = data;
      isOK = this.isStdErrOK(data + "");
    });

    spawner.on("close", (code) => {
      isOK = isOK && code === 0;
      this.emit(isOK ? "dicom-test-success" : "dicom-test-failed", resData);
    });
    spawner.on("exit", (code) => {
      logStdout(`test dicom - ${type} exit code`, code);
    });

    spawner.on("error", (err) => {
      logStdout(`test dicom - error`, err.message || "");
      this.emit("dicom-test-failed", err.message);
    });
  }

  isStdErrOK(data) {
    if (!isDefined(data)) return true;
    let allLines = data.split("\n");
    return allLines.every((item) => {
      return item.indexOf("E:") < 0;
    });
  }
  addPatient2Db(pats, callback) {
    if (pats.length <= 0) {
      this.execCallback(callback);
    } else {
      let pat = pats.pop();
      getOnePatient(
        {
          search: {
            $and: [{ firstname: pat.firstname }, { lastname: pat.lastname }, { pid: pat.pid }]
          },
          matchall: true
        },
        (data) => {
          if (data.message === "OK") {
            if (!isDefined(data.patient)) {
              logStdout("dicom-add local patient", pat);
              addPatient(pat, (data) => {
                logStdout("dicom-add local patient response", data);
                if (data.message === "OK") {
                  this.addPatient2Db(pats, callback);
                } else {
                  this.execCallback(new Error("add patient error"), callback);
                }
              });
            } else {
              this.addPatient2Db(pats, callback);
            }
          } else {
            this.execCallback(new Error("get one patient error"), callback);
          }
        }
      );
    }
  }
  stopDownloadPatient() {
    isDownloading = false;
    for (let id in DCMTKTOOLS) {
      fileSys.killallExe(DCMTKTOOLS[id]);
    }
    clearTimeout(timeout);
  }
  downLoadPatient(callback) {
    isDownloading = true;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      this.getWorklistData((error) => {
        if (isDefined(error)) {
          if (isDownloading && isFunction(callback)) {
            this.execCallback(error, callback);
          }
        } else {
          let patients = this.procLocalPatient();
          this.addPatient2Db(patients, (error) => {
            this.execCallback(error, callback);
            if (isDownloading) {
              this.downLoadPatient(callback);
            }
          });
        }
      });
    }, window.dicomSettings.interval * 1000);
  }
  dicomInfo2wl(info, callback) {
    if (!info || !info.dataset) return;
    let txt = "";
    info.dataset.forEach((el) => {
      txt +=
        el.vr !== "na"
          ? `(${el.tag}) ${el.vr} ${el.value === "" ? "" : "[" + el.value + "]"} \r\n`
          : `(${el.tag}) ${el.value} \r\n`;
    });

    let dumppath = fileSys.getTmpFilePath("temp.dump");
    let wlpath = fileSys.getTmpFilePath("temp.wl");
    fileSys.writeFileSync(dumppath, txt);
    let cmd = `${this.getUtilFilePath(DCMTKTOOLS.dump2dcm)} ${dumppath} ${wlpath} --write-xfer-little`;
    logStdout("dicom-patient info to wl cmd", cmd);
    exec(cmd, ENV, (error) => {
      if (error) logStdout("dump2dcm", error.message || "");
      if (callback) callback(error, wlpath);
    });
  }
  dcmDjpeg(dcmsrc, dcmdst, callback) {
    const cmd = `${this.getUtilFilePath(DCMTKTOOLS.dcmdjpeg)} ${dcmsrc} ${dcmdst}`;
    exec(cmd, ENV, (error) => {
      if (error) logStdout("dicom-dcmDjpeg error", error.message || "");
      if (callback) callback(error);
    });
  }
  img2dcmAndUplad(patient, record, imagePaths, wlpath, callback) {
    if (imagePaths.length <= 0) {
      if (callback) callback();
    } else {
      const imgpath = imagePaths.pop();

      const tempdcmpath = fileSys.getTmpFilePath("temp.dcm");
      const tempdcmpath2 = fileSys.getTmpFilePath("temp2.dcm");
      let extname = fileSys.getFileExternName(imgpath).replace(".", "").toUpperCase();
      if (extname === "JPG") extname = "JPEG";
      let cmd = "";
      if (extname === "PNG") {
        cmd = `${this.getUtilFilePath(DCMTKTOOLS.img2dcm)} ${imgpath} ${tempdcmpath} -df ${wlpath}`;
      } else {
        cmd = `${this.getUtilFilePath(DCMTKTOOLS.img2dcm)} -i ${extname} ${imgpath} ${tempdcmpath} -df ${wlpath}`;
      }
      logStdout("dicom-image to dump cmd", cmd);
      exec(cmd, ENV, (error) => {
        if (error) {
          console.log("img2dcm error", error);
          if (error) logStdout("img2dcm error", error.message || "");
          callback(error);
        } else {
          this.dcmDjpeg(tempdcmpath, tempdcmpath2, (err) => {
            if (err) {
              logStdout("dicom-dcmDjpeg error", err.message || "");
              callback(error);
            } else {
              this.uploadDCM(tempdcmpath2, (error) => {
                console.log("dicom-uploadDCM error", error);
                if (error) {
                  callback(error);
                } else {
                  this.img2dcmAndUplad(patient, record, imagePaths, wlpath, callback);
                }
              });
            }
          });
        }
      });
    }
  }
  uploadImage2DicomSvr(patient, record, imgdir) {
    let imagePaths = fileSys.readDirectory(imgdir);

    const { dicominfo } = patient;
    if (dicominfo) {
      this.dicomInfo2wl(dicominfo, (error, wlpath) => {
        if (error) {
          this.emit("dicom-failed");
        } else {
          this.img2dcmAndUplad(patient, record, imagePaths, wlpath, (error) => {
            if (error) {
              this.emit("dicom-failed");
            } else {
              this.emit("dicom-ok");
            }
          });
        }
      });
    } else {
      this.emit("dicom-failed");
    }
  }
  uploadDCM(dcmpath, callback) {
    let storescu = this.getUtilFilePath(DCMTKTOOLS.storescu);
    const { pdf } = window.dicomSettings;
    const { serverip, serverport, aetitle, localae } = pdf;
    // cmd = `${this.getUtilFilePath(DCMTKTOOLS.storescu)} ${window.dicomSettings.pdf.serverip} ${window.dicomSettings.pdf.serverport} ${temppdfPath}`
    let cmd = `${storescu} ${serverip} ${serverport} -aec ${aetitle} -aet ${localae} ${dcmpath}`;
    logStdout("dicom-upload pdf to dicom server cmd", cmd);
    exec(cmd, ENV, (error) => {
      if (error) logStdout("dicom-upload pdf to dicom server error", error.message || "");
      if (callback) callback(error);
    });
  }
  uploadPdf2DicomSvr(patient, filepath, record = {}) {
    let name = patient.firstname ? patient.firstname : "";
    if (isDefined(patient.lastname) && !isStringEmpty(patient.lastname)) {
      name += `^${patient.lastname}`;
    }
    let pid = isDefined(patient.pid) ? patient.pid : "";
    let sex = (isDefined(patient.sex) ? patient.sex : "O") || "O";
    let birthday = isDefined(patient.birthday) ? patient.birthday.replace(/-/g, "") : "";
    let pdfPath = filepath.replace(/(\s+)/g, '" "');
    if (window.dicomSettings.pdf.worklistcharset.toLowerCase() === "gbk") {
      name = encoding.convert(name, "GBK", "utf8");
      // sex = encoding.convert(sex, 'GBK', 'utf8')
    }
    let temppdfPath = this.getConfigFilePath("pdf.dcm");
    if (fileSys.isFileExists(temppdfPath)) fileSys.deleteFile(temppdfPath);
    let cmd = `${this.getUtilFilePath(DCMTKTOOLS.pdf2dcm)} +pn ${name} +pi ${pid} +ps ${sex} ${birthday ? "+pb " + birthday : ""} ${pdfPath} ${temppdfPath}`;
    logStdout("dicom-pdf to dcm command", cmd);
    exec(cmd, ENV, (error) => {
      if (error) {
        logStdout("dicom-pdf to dcm error", error.message || "");
        this.emit("dicom-failed");
      } else {
        if (!isDefined(patient.dicominfo)) {
          this.emit("dicom-failed");
          return;
        }
        // 字符集 `0008,0005=`
        this.modifyDCM(patient, record, temppdfPath, (err) => {
          if (err) {
            logStdout("dicom-upload pdf to dicom server error", err.message || err);
            this.emit("dicom-failed");
            return;
          }
          this.uploadDCM(temppdfPath, (error) => {
            if (error) {
              logStdout("dicom-upload pdf to dicom server error", error.message || "");
              this.emit("dicom-failed");
            } else {
              this.emit("dicom-ok");
            }
          });
        });
      }
    });
  }
}
export default Dicom;



// WEBPACK FOOTER //
// ./src/mainInterface/js/dicom/Dicom.js